import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { ReactReader } from 'react-reader';
// import { EpubView } from "react-reader";
// import ReactQuill from 'react-quill'
import M from 'materialize-css'
import AdmZip from 'adm-zip' //https://stackoverflow.com/questions/10359485/how-to-download-and-unzip-a-zip-file-in-memory-in-nodejs
import { saveMasterpiece } from '../../../store/actions/publisherActions'
import { epubToHtml } from '../../../store/actions/epubActions'
import { getTextToSpeech } from '../../../store/actions/epubActions'
import { saveAudioFile } from '../../../store/actions/epubActions'


class ShowEpub extends Component {

    state = {
        htmlToShow: "Yo yo yo",
        htmlText: "",
        textOnly: "",
        speech: null
    }

    // fileName = React.createRef(); 
    // quillRef = null;      // Quill instance
    // reactQuillRef = null; // ReactQuill component

    // attachQuillRefs = () => {
    //     if (typeof this.reactQuillRef.getEditor !== 'function') return;
    //     this.quillRef = this.reactQuillRef.getEditor();
    // }

    saveMasterpiece = (e) => {
        const chapter = this.props.chapter
        const chapterFile = this.props.chapterFile
        const newText = this.state.htmlToShow
        this.props.saveMasterpiece(chapter, chapterFile, newText)
    }


    //https://stackoverflow.com/questions/10359485/how-to-download-and-unzip-a-zip-file-in-memory-in-nodejs
    http = require('http');
    getUnzipEpub = (file_url, callback) => {
        this.http.get(file_url, function (res) {
            // res.setHeader('Access-Control-Allow-Origin', '*')
            var data = [], dataLen = 0;

            res.on('data', function (chunk) {
                data.push(chunk);
                dataLen += chunk.length;

            }).on('end', function () {
                var buf = Buffer.alloc(dataLen);

                for (var i = 0, len = data.length, pos = 0; i < len; i++) {
                    data[i].copy(buf, pos);
                    pos += data[i].length;
                }

                var zip = new AdmZip(buf);
                var zipEntries = zip.getEntries();

                // console.log("ZIP")
                // console.log(zip)
                // console.log("ZIP ENTRIES")
                // console.log(zipEntries)

                const entry6Data = zipEntries[6].getData()

                // https://stackoverflow.com/questions/13950865/javascript-render-png-stored-as-uint8array-onto-canvas-element-without-data-uri
                // https://stackoverflow.com/questions/34389649/javascript-blob-document-with-html-tags-to-be-saved-with-formatting
                // https://stackoverflow.com/questions/50620821/uint8array-to-image-in-javascript/50621529

                const blob = new Blob([entry6Data], { 'type': 'image/png' });
                // console.log("Entry 6")
                const thisurl = URL.createObjectURL(blob)
                // console.log(blob)
                // console.log(zip)
                // zip.extractAllTo(/*target path*/"/Macintosh_HD⁩/Users⁩/aaron⁩/Desktop⁩/unzippedStuff/here", /*overwrite*/true);

                const xhtmltext = zip.readAsText(zipEntries[3])
                // console.log(xhtmltext)


                callback(xhtmltext)



                for (var i = 0; i < zipEntries.length; i++) {
                    // console.log("Entry")
                    // console.log(zipEntries[i])
                    if (zipEntries[i].entryName.match(/readme/)) {
                        // console.log("ENTRIES")
                        // console.log(zipEntries[i].entryName)
                        // console.log(zip.readAsText(zipEntries[i]));
                    }
                }
            });
        });
    }

    showEpubFromUrl = () => {
        // console.log("1")
        const chapter = this.props.chapter
        const chapterFile = this.props.chapterFile
        const url = this.props.fileUrl

        this.props.epubToHtml(chapter, chapterFile, url)
        // console.log("100")

        // this.getUnzipEpub(url, (htmlText) => {
        //     this.setState({
        //         htmlToShow: htmlText
        //     })    
        // });
    }

    downloadEpub = () => {
        const url = this.props.fileUrl
        this.getUnzipEpub(url, (htmlText) => {
            this.setState({
                htmlToShow: htmlText
            })
        });
    }

    downloadText = (callback) => {
        // console.log("In downloadText")
        const http = require('http');
        const epubUrl = this.props.chapterFile.epubHtmlUrl
        http.get(epubUrl, function (res) {
            // res.setHeader('Access-Control-Allow-Origin', '*')
            var data = [], dataLen = 0;

            res.on('data', function (chunk) {
                data.push(chunk);
                dataLen += chunk.length;

            }).on('end', function () {
                var buf = Buffer.alloc(dataLen);

                for (var i = 0, len = data.length, pos = 0; i < len; i++) {
                    data[i].copy(buf, pos);
                    pos += data[i].length;
                }
                // console.log("Text Downloaded")
                // const text = new TextDecoder("utf-8").decode(data[0])
                // console.log(text)
                const htmlText = new TextDecoder("utf-8").decode(buf)
                // console.log(text)
                callback(htmlText)
            });
        });
    }

    noRightClick = (e) => {
        // console.log("clicked my epub")
        e.preventDefault();
    }


    //Delete this block.
    //This was removed 10/2/19 and moved to epubActions.js
    /*
    //This doesn't work
    extractContent = (s) => {
        var span = document.createElement('span');
        span.innerHTML = s;
        return span.textContent || span.innerText;
      };
      
    //This doesn't work
    stripHtml = (html) => {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //This seems to work. I got it here:
    //https://stackoverflow.com/questions/822452/strip-html-from-text-javascript/47140708#47140708
    strip = (html) => {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }


    readEpub = (htmlText) => {
        const textOnly = this.strip(htmlText)
        console.log("TEXT ONLY")
        console.log(textOnly)

        this.getTextToSpeech( textOnly, (responseText) => {
            const jsonResponse = JSON.parse(responseText)
            const base64Audio = jsonResponse.audioContent
            console.log(base64Audio)
            const mp3Audio = window.atob(base64Audio)
            // console.log(mp3Audio)
            this.setState({
                // speech: mp3Audio
                speech: base64Audio
            })
        })
    }

    getTextToSpeech = (textOnly, callback) => {
        //Example content
        //https://cloud.google.com/text-to-speech/docs/quickstart-protocol
        //https://cloud.google.com/text-to-speech/docs/reference/rest/v1/text/synthesize#SynthesisInput
        const requestContent = {
            "input": {
                "text": textOnly
            },
            'voice': {
                'languageCode': 'es-ES',
                'name': 'es-ES-Standard-A',
                'ssmlGender': 'FEMALE'
            },
            'audioConfig': {
                'audioEncoding': 'MP3'
            }
        }

        //This block works for getting synthesized speech
        //https://stackoverflow.com/questions/9713058/send-post-data-using-xmlhttprequest
        var http = new XMLHttpRequest();
        var url = "https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyAJrbtpM53WhdMGU_mKgAWvcmkUuO7LbhQ"
        var params = 'orem=ipsum&name=binny';
        http.open('POST', url, true);
        
        //Send the proper header information along with the request
        http.setRequestHeader("Content-Type", "application/json");       
        
        http.onreadystatechange = function() {//Call a function when the state changes.
            if(http.readyState == 4 && http.status == 200) {
                alert(http.responseText);
                callback(http.responseText)
            }
        }
        http.send(JSON.stringify(requestContent));
    }
*/

    getTTS = (e, voiceObject) => {
        const chapter = this.props.chapter
        const chapterFile = this.props.chapterFile
        const htmlText = this.state.htmlText
        // console.log("CHAPTER FILE")
        // console.log(chapterFile)
        this.props.getTextToSpeech(chapter, chapterFile, voiceObject) //This function was modified on 7/23
    }

    uploadAudio = (e) => {
        const chapter = this.props.chapter
        const chapterFile = this.props.chapterFile
        console.log("Hey Hey Hey")
        console.log(e.target.files[0])
        const audioFile = e.target.files[0]
        this.props.saveAudioFile(chapter, chapterFile, audioFile)
    }

    getAudioControls = () => {
        if (!this.props.chapterFile.hasOwnProperty("audioUrl")) { return null }
        const ttsAudio = this.props.chapterFile.audioUrl
        const audioControls = (
            <div>
                <audio className="epub-audiocontrols" controls controlsList="nodownload" ref={ref => (this.player = ref)}>
                    <source src={ttsAudio} type="audio/mp3" />
                    Your browser does not support the audio element.
                </audio>
            </div>
        )
        return audioControls
    }

    componentDidMount() {
        // this.attachQuillRefs()
        // console.log("sHOWePUB dIDmOUNT. this is the state")
        // console.log(this.props.state)
        this.downloadText((htmlText) => {
            // this.readEpub(htmlText)
            this.setState({
                htmlText: htmlText,
                audioUrl: this.props.chapterFile.audioUrl
            })
        });

        // var images = document.querySelectorAll('.materialboxed')
        // console.log("IMAGES")
        // console.log(images)
        // const options = {};
        // M.Materialbox.init(images, options);
        // const url = this.props.fileUrl
        // console.log("URL")
        // console.log(url)
        // this.getUnzipEpub(url, (htmlText) => {
        //     this.setState({
        //         htmlToShow: htmlText
        //     })    
        // });
    }

    componentDidUpdate(prevProps) {
        const epubUrl = this.props.chapterFile.epubHtmlUrl
        const prevEpubUrl = prevProps.chapterFile.epubHtmlUrl
        const audioUrl = this.props.chapterFile.audioUrl
        const prevAudioUrl = this.state.audioUrl
        // console.log("PREV URL")
        // console.log(prevAudioUrl)
        // console.log("NEW URL")
        // console.log(audioUrl)
        if (epubUrl !== prevEpubUrl) {
            // if (this.props.chapterFile.hasOwnProperty("audioUrl")) { this.player.load() }
            this.downloadText((htmlText) => {
                this.setState({
                    htmlText: htmlText,
                    audioUrl: this.props.chapterFile.audioUrl
                })
            });
        } else if (audioUrl !== prevAudioUrl) {
            // alert("TTS Audio Updated")
            this.setState({
                audioUrl: this.props.chapterFile.audioUrl
            })
        }

        // console.log("ShowEpub DidUpdate")
        // Typical usage (don't forget to compare props):
        // if (this.props.userID !== prevProps.userID) {
        //     this.fetchData(this.props.userID);
        // }
    }

    getUploadAudioBtn = () => { //Old and can be deleted as of 7/23/20. This function was transferred to PublisherFeatures.js and modified.
        const userEmail = this.props.auth.email
        if (!(
            userEmail === "ajstephens@gmail.com" ||
            userEmail === "bwentzel@gmail.com" ||
            userEmail === "lance.piantaggini@gmail.com" ||
            userEmail === "laura@cencis.com" ||
            userEmail === "hginni@comcast.net" ||
            userEmail === "aolimpi@hebronlions.org"
        )) { return null }

        const bookId = this.props.bookId

        return (
            <div className="audiobutton-container">
                <div className="tts-button2" >
                    <input type="file" name="file" accept="audio/mpeg3" onChange={this.uploadAudio} />
                    {/* <button className="btn" type="button" onClick={(e) => this.uploadAudio(e)}> */}
                    {/* <button className="btn" type="button" > */}
                    {/* <span>Upload Audio File</span> */}
                    {/* </button> */}
                </div>
            </div>
        )
    }


    getTtsButton = () => {  //Old and can be deleted as of 7/23/20. This function was transferred to PublisherFeatures.js and modified.
        // if (this.props.chapterFile.hasOwnProperty("audioUrl")) { return null }
        const userEmail = this.props.auth.email
        if (!(
            userEmail === "ajstephens@gmail.com" ||
            userEmail === "bwentzel@gmail.com" ||
            userEmail === "laura@cencis.com" ||
            userEmail === "hginni@comcast.net" ||
            userEmail === "aolimpi@hebronlions.org"
        )) { return null }

        const bookId = this.props.bookId
        const language = this.props.state.books.booksPurchased[bookId] ?
            this.props.state.books.booksPurchased[bookId]["language"] ?
                this.props.state.books.booksPurchased[bookId]["language"] :
                "English" :
            "English"
        // const language = this.props.state.books.books[bookId] ?
        //     this.props.state.books.books[bookId]["language"] ?
        //         this.props.state.books.books[bookId]["language"] :
        //         "English" :
        //     "English"
        let voiceList = this.props.state.books.ttsLanguages[language] ?
            this.props.state.books.ttsLanguages[language] :
            {
                "en-US Male 1": {
                    'languageCode': 'en-US',
                    'name': 'en-US-Wavenet-A',
                    'ssmlGender': 'MALE'
                },
            }
        if (language === "Latin") {
            // const voicesSpanish = this.props.state.books.ttsLanguages["Spanish"]
            // const voicesItalian = this.props.state.books.ttsLanguages["Italian"]
            // voiceList = {...voicesSpanish, ...voicesItalian}
            voiceList = this.props.state.books.ttsLanguages["Italian"]
        }
        // console.log("Which List?")
        // console.log(voiceList)
        const voiceListArr = Object.entries(voiceList)
        const voiceButtons = voiceListArr.map((voice) => {
            const voiceLabel = voice[0]
            const voiceObject = voice[1]
            return (
                <div key={voiceLabel} className="tts-button2" >
                    <button className="btn" type="button" onClick={(e) => this.getTTS(e, voiceObject)}>
                        <span>{voiceLabel}</span>
                    </button>
                </div>
            )
        })
        return (
            <div className="ttsbutton-container">
                {voiceButtons}
            </div>
        )
    }

    render() {


        // const StreamZip = require('node-stream-zip');
        // console.log("STREAMZIP")
        // console.log(StreamZip)
        // const fileUrl = this.props.fileUrl;
        // console.log("FILE URL")
        // console.log(fileUrl);
        // const localFilePath = "../../../../public/img/VersionD2.cce5 (7).epub"
        // const zip = new StreamZip({
        //     file: fileUrl,
        //     storeEntries: true
        // });        
        // // Handle errors
        // zip.on('error', err => { 
        //     console.log("ERROR")
        //     console.log(err)
        //  });

        // const epubHtmlUrl = this.props.chapterFile.epubHtmlUrl
        // console.log("EPUB html url")
        // console.log(epubHtmlUrl)

        // var stylesIframe = {
        //     flexGrow: "1",
        //     border: "none",
        //     margin: "0",
        //     padding: "0"
        // };

        // let ttsAudio = this.state.speech
        // console.log("TTS AUDIO")
        // console.log(ttsAudio)
        // ttsAudio = "data:audio/wav;base64,"+ttsAudio
        // const ttsButtons = this.getTtsButton()
        // const audioButton = this.getUploadAudioBtn()

        // Commented on 7/20/21. These controls were moved to StoryPage.
        // const audioControls = this.getAudioControls() 
        const audioControls = null

        const cssClass = this.props.hasAudioControls ? "iframe-containpdf-audio-controls" : "iframe-containpdf"

        const epub = (

            <div className="epub-center">

                {/* {audioButton} */}
                {/* {ttsButtons} */}
                {/* <div className="tts-button">
                    <button className="btn" type="button" onClick={this.getTTS}>
                        <span>Get TTS Audio</span>
                    </button>
                </div> */}

                {/* <div style={{ display: "block" }}>
                    Hi There
                    <ReactQuill
                        ref={(el) => { this.reactQuillRef = el }}
                        name="editor"
                    />

                </div>  */}

                {audioControls}


                {/* <audio controls="controls" autobuffer="autobuffer" autoplay="autoplay">
                    <source src="data:audio/wav;base64,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" />
                    <source src={ttsAudio} />
                </audio> */}

                <div className="display-center">
                    <div className={cssClass + " shadow"}>
                        <div className="disable-select">
                            <div dangerouslySetInnerHTML={{ __html: this.state.htmlText }}></div>
                        </div>
                    </div>
                </div>
                {/* <div className="text-cover"></div> */}
                {/* <div>{this.state.htmlToShow}</div> */}
                {/* <div dangerouslySetInnerHTML={{__html: this.state.htmlToShow}}></div> */}
                {/* <div className="container"> */}
                {/* <div className="row"> */}
                {/* <div className="video-container"> */}
                {/* <iframe height='100%' width='100%' scrolling='no' allowFullScreen webkitallowfullscreen="true" src={fileUrl}></iframe> */}


                {/* <div className="iframe-container" > */}
                {/* <iframe src={epubHtmlUrl} allowFullScreen ></iframe> */}
                {/* </div> */}


                {/* <iframe width="853" height="700" src={fileUrl} frameBorder="0" allowFullScreen></iframe> */}
                {/* </div> */}
                {/* </div> */}
                {/* </div> */}
            </div>
        )

        // let toDisplay = epub

        // if (this.props.state.chapters.uploadingAudio || this.props.state.books.uploadingEpub) {
        // toDisplay = (
        {/* <div className="myclassrooms-container"> */ }
        {/* <div className="loader"></div> */ }
        {/* </div> */ }
        // )
        // }

        return (
            epub
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        state,
        auth: state.firebase.auth,
        user: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveMasterpiece: (chapterFile, newText, chapter) => dispatch(saveMasterpiece(chapterFile, newText, chapter)),
        epubToHtml: (chapter, chapterFile, epubUrl) => dispatch(epubToHtml(chapter, chapterFile, epubUrl)),
        getTextToSpeech: (chapter, chapterFile, htmlText, voiceObject) => dispatch(getTextToSpeech(chapter, chapterFile, htmlText, voiceObject)),
        saveAudioFile: (chapter, chapterFile, audioFile) => dispatch(saveAudioFile(chapter, chapterFile, audioFile)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowEpub)





